"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useId, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { cn } from "utils/helpers/cn";
interface ReadMoreProps {
  text: string;
  lines?: number;
  labelContext?: string;
}
export default function ReadMore(t0) {
  const $ = _c(30);
  const {
    text,
    lines: t1,
    labelContext
  } = t0;
  const lines = t1 === undefined ? 2 : t1;
  const {
    formatMessage
  } = useIntl();
  const [clamped, setClamped] = useState(true);
  const [showButton, setShowButton] = useState(false);
  const containerRef = useRef(null);
  const id = useId();
  const t2 = clamped ? "show_more" : "show_less";
  let t3;
  if ($[0] !== formatMessage || $[1] !== t2) {
    t3 = formatMessage({
      id: t2
    });
    $[0] = formatMessage;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const readMoreText = t3;
  const clampClass = `line-clamp-${lines}`;
  let t4;
  if ($[3] !== clamped) {
    t4 = () => {
      setClamped(!clamped);
    };
    $[3] = clamped;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleClick = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      const hasClamping = _temp;
      const checkButtonAvailability = () => {
        if (containerRef.current) {
          setShowButton(hasClamping(containerRef.current));
        }
      };
      checkButtonAvailability();
      window.addEventListener("resize", checkButtonAvailability);
      return () => {
        window.removeEventListener("resize", checkButtonAvailability);
      };
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== clampClass) {
    t6 = [clampClass];
    $[6] = clampClass;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  useEffect(t5, t6);
  const t7 = clamped && clampClass;
  let t8;
  if ($[8] !== t7) {
    t8 = cn("[word-break:break-word]", t7);
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== clamped || $[11] !== showButton) {
    t9 = showButton && {
      "aria-hidden": clamped
    };
    $[10] = clamped;
    $[11] = showButton;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== text) {
    t10 = {
      __html: text
    };
    $[13] = text;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== id || $[16] !== t10 || $[17] !== t8 || $[18] !== t9) {
    t11 = <div ref={containerRef} className={t8} id={id} {...t9} dangerouslySetInnerHTML={t10} />;
    $[15] = id;
    $[16] = t10;
    $[17] = t8;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== clamped || $[21] !== handleClick || $[22] !== id || $[23] !== labelContext || $[24] !== readMoreText || $[25] !== showButton) {
    t12 = showButton && <button type="button" onClick={handleClick} data-test-id="read-more-button" className={cn("cursor-pointer border-0 bg-none font-bold ring-offset-background", "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2")} aria-label={`${readMoreText}: ${labelContext ?? ""}`} aria-controls={id} aria-expanded={!clamped}>{readMoreText}</button>;
    $[20] = clamped;
    $[21] = handleClick;
    $[22] = id;
    $[23] = labelContext;
    $[24] = readMoreText;
    $[25] = showButton;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = <div className="flex flex-col items-start gap-n1 text-sm">{t11}{t12}</div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}
function _temp(el) {
  const {
    clientHeight,
    scrollHeight
  } = el;
  return clientHeight !== scrollHeight;
}